import { Product } from "@/api/product-api";
import { isDiscontinued } from "@/components/tactsuit/PriceDisplay";
import { CurrencyIsoCode } from "@/enums";
import { ProductUtil } from "@/utils/ProductUtil";
import { isSoldOutLimitedEdition } from "@/libs/product/limited-edition";

/**
 * 판매 목록에 **남기는가** — 이 국가·통화에서 가격이 있거나, 단종(가격 칸에 「단종」 표시)이면 남긴다.
 * 단 **품절된 한정판은 뺀다**(재입고가 없다 — `isSoldOutLimitedEdition`, EXOSHOCK 번들). 홈 EXOSHOCK 팝업도
 * `useValidBundles` → `usePricedFilter` 로 이 판정을 거쳐 같이 내려간다.
 *
 * `usePricedFilter`(화면)의 판정을 훅 밖으로 뺀 것이다 — 서버 SEO·GMC 피드의 번들 판정
 * (`libs/product/bundle-preselect.ts`)이 같은 판정을 써야 화면이 고르는 번들과 어긋나지 않는다.
 * 규칙의 근거는 `usePricedFilter` docblock.
 */
export function isPricedForListing(
  product: Product,
  {
    currency,
    countryCode,
  }: { currency: CurrencyIsoCode; countryCode: string | null | undefined },
): boolean {
  if (isSoldOutLimitedEdition(product)) return false;
  return (
    isDiscontinued(product.slug) ||
    !!ProductUtil.getProductPrice({ currency, countryCode, product })
  );
}
